// extracted by mini-css-extract-plugin
export default {"wrapper":"context-menu_wrapper__l1KPU","menuButton":"context-menu_menuButton__+Rybr","menuItem":"context-menu_menuItem__ivyc3","icon":"context-menu_icon__9qkPq"};